import confirmVue from './index.vue'

// 定义插件对象
const CusComfirm = {}
// vue的install方法，用于定义vue插件
CusComfirm.install = function (Vue, options) {
  // 结局_t undefined 问题
  confirmVue.i18n = window.i18n
  // 构造器创建子类组件
  const ConfirmInstance = Vue.extend(confirmVue)
  // 定义当前组件对象
  let currentConfirm
  // 实例化挂在模板
  const initInstance = () => {
    // 实例化vue实例
    currentConfirm = new ConfirmInstance()
    const msgBoxEl = currentConfirm.$mount().$el
    document.body.appendChild(msgBoxEl)
  }
  // 在Vue的原型上添加实例方法，以全局调用
  window.$confirm = Vue.prototype.$confirm = {
    /**
         * 原生传参方法
         */
    show(options) {
      // 判断实例是否存在,并创建
      if (!currentConfirm) {
        initInstance()
      }
      // 合并对象
      if (typeof options === 'object') {
        Object.assign(currentConfirm, options)
      }
    },
    /**
         * 隐藏组件的方法
         */
    hide() {
      Object.assign(currentConfirm, { value: false, isShow: false })
    },
    /**
     * 获取当前实例的对象
     */
     getInstance() {
      return currentConfirm || undefined
    }
  }
}
export default CusComfirm
